import React from 'react';
import classnames from 'classnames';

// Types
import { TableHeaderProps, SortDirections } from './types';

// Components
import WpIcon from '../icon/WpIcon';
import { WpCheckbox } from '../checkbox';

// Styles
import './TableHeader.scss';

const TableHeader = ({
  tableId,
  columns,
  sortedColumn,
  sortedDirection,
  setSortColumn,
  setSortDirection,
  hasNesting,
  selectable = false,
  handleSelectAllChange,
  data,
  selectedRowKeys,
}: TableHeaderProps) => {
  const baseClassName = 'TableHeader';

  const isSelectAllChecked = selectedRowKeys.length === data.length;

  const handleSortClick = ({ column }) => {
    if (column.isSortable === false || !column.selector) return;
    const isColumnSorted = sortedColumn && sortedColumn === column.label;
    const direction =
      isColumnSorted && sortedDirection === SortDirections.ASC ? SortDirections.DSC : SortDirections.ASC;

    if (isColumnSorted && sortedDirection === SortDirections.DSC) {
      setSortColumn(null);
      setSortDirection(null);
    } else {
      setSortColumn(column.label);
      setSortDirection(direction);
    }
  };

  const handleSelectAllCheckboxOnChange = () => {
    handleSelectAllChange();
  };

  const SortIcon = ({ column }) => {
    // only show the sort icon if the column is sortable.
    // this does not affect the default sort order
    if (column.isSortable === false || !column.selector) return null;

    const isColumnSorted = sortedColumn && sortedColumn === column.label;

    if (isColumnSorted && sortedDirection === SortDirections.ASC) {
      return (
        <div className={`${baseClassName}__header__sort-icon ${baseClassName}__header__sort-icon--sorted`}>
          <WpIcon prefix="fas" name="sort-up" />
        </div>
      );
    }

    if (isColumnSorted && sortedDirection === SortDirections.DSC) {
      return (
        <div className={`${baseClassName}__header__sort-icon ${baseClassName}__header__sort-icon--sorted`}>
          <WpIcon prefix="fas" name="sort-down" />
        </div>
      );
    }

    return (
      <div className={`${baseClassName}__header__sort-icon`}>
        <WpIcon prefix="fas" name="sort" />
      </div>
    );
  };

  return (
    <thead className={baseClassName}>
      <tr>
        {selectable && (
          <td className={`${baseClassName}__th ${baseClassName}__th--fit-content`}>
            <WpCheckbox
              id="select-all-checkbox"
              label={isSelectAllChecked ? 'Unselect all' : 'Select all'}
              checked={isSelectAllChecked}
              labelHidden
              onChange={handleSelectAllCheckboxOnChange}
            />
          </td>
        )}
        {hasNesting && <td className={`${baseClassName}__th ${baseClassName}__th--nested`}></td>}
        {columns
          .filter(column => column.showColumn !== false)
          .map(column => {
            const thClasses = classnames(
              `${baseClassName}__th`,
              column?.rightAlign && `${baseClassName}__th--right-align`
            );
            return (
              <th className={thClasses} key={`${tableId}__th__${column.label}`} style={{ maxWidth: column.maxWidth }}>
                {!column.hideLabel && (
                  <div className={`${baseClassName}__header`} onClick={() => handleSortClick({ column })}>
                    {column.label}
                    <SortIcon column={column} />
                  </div>
                )}
              </th>
            );
          })}
      </tr>
    </thead>
  );
};

export default TableHeader;
